export default {
  header: {
    self: {},
    items: []
  },
  aside: {
    self: {},
    items: [
      {
        title: "Dashboard",
        root: true,
        icon: "flaticon2-dashboard",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.DASHBOARD",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer", "Administrator", "Super Admin", "Support User", "Partner","Marketing", "CRE", "Logistics", "Accounts"]
      },
	  {
        title: "My Wallet",
        root: true,
        icon: "flaticon2-black-back-closed-envelope-shape",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.mywallet",
        type: ["Individual Customer",  "Apartment Customer" ],
        submenu: [
          {
            title: "Add Money",
            bullet: "dot",
            translate: "MENU.addmoney",
            page: "wallet/addmoney",
            type: ["Individual Customer",  "Apartment Customer"]
          },
          {
            title: "Transaction History",
            bullet: "dot",
            translate: "MENU.transaction",
            page: "wallet/transaction",
            type: ["Individual Customer",  "Apartment Customer" ]
          },
        ]
      },
      {
        title: "Book Water",
        root: true,
        icon: "flaticon2-drop",
        page: "transaction/order/book-water",
        bullet: "dot",
        translate: "MENU.BOOK_WATER",
        type: ["Corporate Customer", "Apartment Customer","Individual Customer", "Administrator", "Support User", "Super Admin", "CRE", "Logistics"]
      },     
      {
        title: "Order",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ORDER",
        type: ["Administrator", "Support User",  "Apartment Customer", "Super Admin", "Partners-Management", "CRE"],
        submenu: [
          {
            title: "Orders List",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_LIST",
            page: "transaction/order/order-list",
            type: ["Support User", "Administrator", "Super Admin", "Partners-Management"],
			      custompage: ["/transaction/order/order-track"],
          },         
          {
            title: "Orders History",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_HISTORY",
            page: "transaction/order/order-history",
            type: ["Support User", "Administrator", "Super Admin"]
          },
		  {
            title: "Order Invoice",
            bullet: "dot",
            translate: "MENU.BOOKING.ORDER_INVOICE",
            page: "invoice/order/orderinvoicelist",
            type: ["Administrator", "Super Admin","Corporate Customer", "Apartment Customer"] 
          },
          {
            title: "Order Summary",
            bullet: "dot",
            translate: "MENU.BOOKING.ORDER_SUMMARY",
            page: "transaction/order/order-summary",
            type: ["Corporate Customer", "Apartment Customer"]
          },
		  {
            title: "Order In-Review",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_PENDINGS",
            page: "transaction/order/order-pendings",
            type: ["Administrator", "Support User","Individual Customer", "Apartment Customer"]
          },
		  {page: "invoice/order/createinvoice"},
		  {page: "invoice/order/editinvoice"},
        ]
      },
      {
        title: "Orders",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ORDER.d",
        type: ["Logistics"],
        submenu: [
          {
            title: "Orders List",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_LIST",
            page: "transaction/order/order-list",
            type: ["Support User", "Administrator", "Super Admin", "Partners-Management"],
			      custompage: ["/transaction/order/order-track"],
          },
          {page: "invoice/order/createinvoice"},
          {page: "invoice/order/editinvoice"},
        ]
      },
	  {
        title: "Manage Orders",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ORDER.d",
        type: ["Logistics", "CRE"],
        submenu: [          
          {
            title: "Approval Pending Orders",
            bullet: "dot",
            translate: "MENU.ORDER.Approval.Pending.Orders",
            page: "transaction/order/order-approval-pending",
            type: ["Support User", "Administrator", "Super Admin"]
          },
		      {
            title: "Approved Orders",
            bullet: "dot",
            translate: "MENU.ORDER.Approved.Orders",
            page: "transaction/order/approvedorders",
            type: ["Support User", "Administrator", "Super Admin"]
          },
          {
            title: "Completed Orders",
            bullet: "dot",
            translate: "MENU.ORDER.Completed.Orders",
            page: "transaction/order/completedorders",
            type: ["Support User", "Administrator", "Super Admin"]
          },
          {page: "invoice/order/createinvoice"},
          {page: "invoice/order/editinvoice"},
        ]
      },
      {
        title: "Manage Orders",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ORDER.d",
        type: ["Accounts"],
        submenu: [ 
          {
            title: "Orders List",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_LIST",
            page: "transaction/order/order-list",
            type: ["Support User", "Administrator", "Super Admin", "Partners-Management"],
			      custompage: ["/transaction/order/order-track"],
          },                  
          {
            title: "Pending Orders",
            bullet: "dot",
            translate: "MENU.ORDER.Pending.Orders",
            page: "transaction/order/pendingorders",
            type: ["Support User", "Administrator", "Super Admin"]
          },
		      {
            title: "Completed Orders",
            bullet: "dot",
            translate: "MENU.ORDER.Completed.Orders",
            page: "transaction/order/completedorders",
            type: ["Support User", "Administrator", "Super Admin"]
          },
          {page: "invoice/order/createinvoice"},
          {page: "invoice/order/editinvoice"},
        ]
      },
      {
        title: "Orders",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ORDER.d",
        type: ["Administrator","Marketing"],
        submenu: [ 
          {
            title: "Orders List",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_LIST",
            page: "transaction/order/order-list",
            type: ["Support User", "Administrator", "Super Admin", "Partners-Management"],
			      custompage: ["/transaction/order/order-track"],
          },
		      {
            title: "Orders Status",
            bullet: "dot",
            translate: "MENU.ORDER.Completed.Orders",
            page: "transaction/order/orderstatus",
            type: ["Support User", "Administrator", "Super Admin"]
          }
        ]
      },
	  {

        title: "Order",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ORDER",
        type: ["Corporate Customer"],
        submenu: [
          {
            title: "Orders List",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_LIST",
            page: "transaction/order/order-list",
            type: ["Support User", "Administrator", "Super Admin"]
          },
          {
            title: "Orders History",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_HISTORY",
            page: "transaction/order/order-history",
            type: ["Support User", "Administrator", "Super Admin"]
          },
		  {
            title: "Order Invoice",
            bullet: "dot",
            translate: "MENU.BOOKING.ORDER_INVOICE",
            page: "invoice/order/orderinvoicelist",
            type: ["Administrator", "Super Admin","Corporate Customer", "Apartment Customer"] 
          },
          {
            title: "Order Summary",
            bullet: "dot",
            translate: "MENU.BOOKING.ORDER_SUMMARY",
            page: "transaction/order/order-summary",
            type: ["Corporate Customer", "Apartment Customer"]
          },
		{page: "invoice/order/createinvoice"},
		{page: "invoice/order/editinvoice"},
        ]
      },
	  {
        title: "Order",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ORDER",
        type: [ "Individual Customer"],
        submenu: [
          {
            title: "Orders List",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_LIST",
            page: "transaction/order/order-list",
            type: ["Support User", "Administrator", "Super Admin"]
          },
          {
            title: "Orders History",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_HISTORY",
            page: "transaction/order/order-history",
            type: ["Support User", "Administrator", "Super Admin"]
          },
          {
            title: "Order Summary",
            bullet: "dot",
            translate: "MENU.BOOKING.ORDER_SUMMARY",
            page: "transaction/order/order-summary",
            type: ["Corporate Customer", "Apartment Customer"]
          },
		  {
            title: "Order In-Review",
            bullet: "dot",
            translate: "MENU.ORDER.ORDER_PENDINGS",
            page: "transaction/order/order-pendings",
            type: ["Administrator", "Support User","Individual Customer", "Apartment Customer"]
          },
		  {page: "invoice/order/createinvoice"},
		{page: "invoice/order/editinvoice"},
        ]
      },	  
       {
         title: "Individual Customer",
         root: true,
         icon: "flaticon2-user",
         page: "indiv-customer",
         bullet: "dot",
         translate: "MENU.CUSTOMER",
         type: ["Support User","Administrator","Super Admin", "CRE", "Logistics"],
         submenu: [
           {
             title: "Individual Customer List",
             bullet: "dot",
             translate: "MENU.CUSTOMER.LIST",
             page: "indiv-customer/customer-list",
			 custompage: ["/indiv-customer/customer-create","/indiv-customer/customer-details","/indiv-customer/customer-edit"],
             type: ["Support User","Administrator"]
           },
         ]
       },
      {
        title: "Apartment Customer",
        root: true,
        icon: "flaticon2-user",
        page: "aprt-customer",
        bullet: "dot",
        translate: "MENU.APRT_CUSTOMER",
        type: ["Administrator", "Support User", "Super Admin", "CRE", "Logistics"],
        submenu: [
          {
            title: "Apartment Customer List",
            bullet: "dot",
            translate: "MENU.APRT_CUSTOMER.LIST",
            page: "aprt-customer/customer-list",
			custompage: ["/aprt-customer/customer-create","/aprt-customer/customer-details","/aprt-customer/customer-edit"],
          },
        ]
      },
	  
      {
        title: "Corporate Customer",
        root: true,
        icon: "flaticon2-user",
        page: "corp-customer",
        bullet: "dot",
        translate: "MENU.CORP_CUSTOMER",
        type: ["Administrator", "Support User", "Super Admin", "CRE", "Logistics"],
        submenu: [
          {
            title: "Corporate Customer List",
            bullet: "dot",
            translate: "MENU.CORP_CUSTOMER.LIST",
            page: "corp-customer/customer-list",
			custompage: ["/corp-customer/customer-create","/corp-customer/customer-details","/corp-customer/customer-edit"],
          },
        ]
      },
      {
        title: "Partner",
        root: true,
        icon: "flaticon2-group",
        page: "partner",
        bullet: "dot",
        translate: "MENU.PARTNER",
        type: ["Administrator", "Support User", "Super Admin", "Partners-Management", "Logistics", "CRE"],
        submenu: [
          {
            title: "Partner List",
            bullet: "dot",
            translate: "MENU.PARTNER.LIST",
            page: "partner/partner-list",
            type: ["Administrator", "Support User", "Super Admin"],
			custompage: ["/partner/partner-create","/partner/partner-details","/partner/partner-edit","/partner/partner-assets","/partner/borewell/borewell-create","/partner/borewell/borewell-details","/partner/borewell/borewell-edit","/partner/driver/driver-create","/partner/driver/driver-details","/partner/driver/driver-edit","/partner/fleet/fleet-create","/partner/fleet/fleet-details","/partner/fleet/fleet-edit"],
          },
          {
            title: "Borewell Partner List",
            bullet: "dot",
            translate: "MENU.PARTNER.BOREWELL_PARTNER_LIST",
            page: "partner/borewell-partner-list",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Fleet Partner List",
            bullet: "dot",
            translate: "MENU.PARTNER.FLEET_PARTNER_LIST",
            page: "partner/fleet-partner-list",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Independent Tanker Partner List",
            bullet: "dot",
            translate: "MENU.PARTNER.DRIVER_PARTNER_LIST",
            page: "partner/tanker-partner-list",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Borewell/Fleet Partner List",
            bullet: "dot",
            translate: "MENU.PARTNER.BOREWELL_FLEET_PARTNER_LIST",
            page: "partner/borewell-fleet-partner-list",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Fleet Driver Mapping",
            bullet: "dot",
            translate: "MENU.PARTNER.FLEET_DRIVER_MAPPING",
            page: "partner/fleet-driver-mapping",
            type: ["Administrator", "Support User", "Super Admin"]
          },
        ]
      },
      // {
      //   title: "Borewell",
      //   root: true,
      //   icon: "flaticon2-architecture-and-city",
      //   page: "dashboard",
      //   bullet: "dot",
      //   translate: "MENU.BOREWELL",
      //   submenu: [
      //     {
      //       title: "Borewell Details",
      //       bullet: "dot",
      //       translate: "MENU.BOREWELL.BOREWELL_DETAILS",
      //       page: "borewell/borewell-details"
      //     }
      //   ]
      // },
      // {
      //   title: "Driver",
      //   root: true,
      //   icon: "flaticon2-architecture-and-city",
      //   page: "dashboard",
      //   bullet: "dot",
      //   translate: "MENU.DRIVER",
      //   submenu: [
      //     {
      //       title: "Borewell Details",
      //       bullet: "dot",
      //       translate: "MENU.DRIVER.DRIVER_DETAILS",
      //       page: "driver/driver-details"
      //     }
      //   ]
      // },
      // {
      //   title: "Fleet",
      //   root: true,
      //   icon: "flaticon2-architecture-and-city",
      //   page: "dashboard",
      //   bullet: "dot",
      //   translate: "MENU.FLEET",
      //   submenu: [
      //     {
      //       title: "Fleet Details",
      //       bullet: "dot",
      //       translate: "MENU.FLEET.FLEET_DETAILS",
      //       page: "fleet/fleet-details"
      //     }
      //   ]
      // },
      // {
      //   title: "Order",
      //   root: true,
      //   icon: "flaticon2-architecture-and-city",
      //   page: "dashboard",
      //   bullet: "dot",
      //   translate: "MENU.ORDER",
      //   submenu: [
      //     {
      //       title: "Address",
      //       bullet: "dot",
      //       translate: "MENU.ORDER.CURRENT",
      //       page: "transaction/order/current-order"
      //     }
      //   ]
      // },
      {
        title: "User",
        root: true,
        icon: "flaticon2-user",
        page: "user",
        bullet: "dot",
        translate: "MENU.USER",
        type: ["Administrator", "Super Admin"],
        submenu: [
          {
            title: "Aggregator User",
            bullet: "dot",
            translate: "MENU.USER.AGGREGATOR.LIST",
            page: "user/user-list",
            type: ["Administrator", "Super Admin"],
			custompage: ["/user/user-create"],
          },
           {
             title: "Individual List",
             bullet: "dot",
             translate: "MENU.USER.INDIVIDUAL.LIST",
             page: "user/indiv-list",
             type: ["Administrator", "Super Admin"],
			 custompage: ["/indiv-customer/customer-create-useragg"],
           },
          {
            title: "Apartment List",
            bullet: "dot",
            translate: "MENU.USER.APARTMENT.LIST",
            page: "user/apart-list",
            type: ["Administrator", "Super Admin"],
			custompage: ["/aprt-customer/customer-user-create-agg"],
          },
          {
            title: "Corporate List",
            bullet: "dot",
            translate: "MENU.USER.CORPORATE.LIST",
            page: "user/corp-list",
            type: ["Administrator", "Super Admin"],
			custompage: ["/corp-customer/customer-create-user-agg"],
          },
          {
            title: "Partner List",
            bullet: "dot",
            translate: "MENU.USER.PARTNER.LIST",
            page: "user/partner-list",
            type: ["Administrator", "Super Admin"]
          },
        ]
      },
      {
        title: "Super Admin",
        root: true,
        icon: "flaticon2-user",
        page: "superadmin",
        bullet: "dot",
        translate: "MENU.SUPER_ADMIN",
        type: ["Super Admin"],
        submenu: [
          {
            title: "User",
            bullet: "dot",
            translate: "MENU.SUPER_ADMIN.USER_LIST",
            page: "user/sa-user-list",
            type: ["Super Admin"]
          },
          {
            title: "Partner User",
            bullet: "dot",
            translate: "MENU.SUPER_ADMIN.PARTNER_USER_LIST",
            page: "user/sa-partner-user-list",
            type: ["Super Admin"]
          },
          // {
          //   title: "Individual User",
          //   bullet: "dot",
          //   translate: "MENU.SUPER_ADMIN.INDIVIDUAL_USER_LIST",
          //   page: "user/sa-indiv-user-list",
          //   type: ["Super Admin"]
          // },
          {
            title: "Apartment User",
            bullet: "dot",
            translate: "MENU.SUPER_ADMIN.APARTMENT_USER_LIST",
            page: "user/sa-apart-user-list",
            type: ["Super Admin"]
          },
          {
            title: "Corporate User",
            bullet: "dot",
            translate: "MENU.SUPER_ADMIN.CORPORATE_USER_LIST",
            page: "user/sa-corp-user-list",
            type: ["Super Admin"]
          }
        ]
      },
      {
        title: "Zone Management",
        root: true,
        icon: "flaticon2-map",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.ZONE_MANAGEMENT",
        type: ["Administrator", "Super Admin", "Partners-Management", "Logistics", "Project Engineer", "Marketing"],
        submenu: [
          {
            title: "Distance Table",
            bullet: "dot",
            translate: "MENU.ZONE_MANAGEMENT.DISTANCE_TABLE",
            page: "zone-management/distance-table",
            type: ["Administrator", "Super Admin"]
          },
          {
            title: "Zones",
            bullet: "dot",
            translate: "MENU.ZONE_MANAGEMENT.ZONES",
            page: "zone-management/zones",
            type: ["Administrator", "Super Admin"]
          },
          {
            title: "Nearest Borewell",
            bullet: "dot",
            translate: "MENU.ZONE_MANAGEMENT.NEAREST_BOREWELL",
            page: "zone-management/borewell-distance-from-address",
            type: ["Administrator", "Super Admin"]
          },
          {
            title: "Driver Location",
            bullet: "dot",
            translate: "MENU.ZONE_MANAGEMENT.DRIVER",
            page: "zone-management/driver-location",
            type: ["Administrator", "Super Admin"]
          }
        ]
      },
	  {
        title: "Water Tank",
        root: true,
        icon: "flaticon-placeholder-2",
        page: "Water Tank",
        bullet: "dot",
        translate: "MENU.Water_Tank",
        type: ["Administrator", "Support User", "Corporate Customer", "Apartment Customer", "Individual Customer", "Super Admin", "Partners-Management", "Marketing", "CRE", "Logistics", "Project Engineer"],
        submenu: [
          {
            title: "Tank",
            bullet: "dot",
            translate: "MENU.Water_Tank.Tank",
            page: "water-tank/tank-list",
            type: ["Administrator", "Super Admin","Marketing"],
			custompage: ["/water-tank/tank-create","/water-tank/tank-view","/water-tank/tank-flow-view","/water-tank/tank-edit"],
          }
        ]
      },
	  {
        title: "Lead Management",
        root: true,
        icon: "flaticon2-map",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.MARKET_TARGET_LEAD",
        type: ["Administrator", "Support User","Super Admin"],
        submenu: [
		  {
            title: "All leads",
            bullet: "dot",
            translate: "MENU.TARGET_LEAD_LIST_ALL",
            page: "market-target-lead/customer-list",
            type: ["Administrator", "Support User","Super Admin"],
          }
        ]
      },
	  {
        title: "Lead Management",
        root: true,
        icon: "flaticon2-map",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.MARKET_TARGET_LEAD",
        type: ["Marketing"],
        submenu: [
         {
            title: "My Leads",
            bullet: "dot",
            translate: "MENU.TARGET_LEAD_LIST",
            page: "market-target-lead/customer-particular-list",
            type: ["Marketing"],
			//custompage: ["market-target-lead/customer-list"],
          },
		  {
            title: "All leads",
            bullet: "dot",
            translate: "MENU.TARGET_LEAD_LIST_ALL",
            page: "market-target-lead/customer-list",
            type: ["Marketing"],
			//custompage: ["market-target-lead/customer-list-all"],
          }
        ]
      },
	  {
        title: "Tank",
        root: true,
        icon: "flaticon2-drop",
        page: "Tank",
        bullet: "dot",
        translate: "MENU.Tank",
        type: ["Sales"],
        submenu: [
          {
            title: "IoT - Level Sensor",
            bullet: "dot",
            translate: "MENU.Tank.Level_Sensor",
            page: "water-tank/demo-tank-view",
            type: ["Sales"]
          },
		   {
            title: "Flow Meter",
            bullet: "dot",
            translate: "MENU.Tank.Flow_Meter",
            page: "water-tank/demo-tank-flow-view",
            type: ["Sales"]
          }
        ]
      },
      {
        title: "Manage",
        root: true,
        icon: "flaticon-user-settings",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.MANAGE",
        type: ["Administrator", "Super Admin"],
        submenu: [
          {
            title: "Borewell Summary",
            bullet: "dot",
            translate: "MENU.MANAGE.BOREWELL_SUMMARY",
            page: "manage/borewell-summary",
            type: ["Administrator", "Super Admin"]
          },
          {
            title: "Fleet Summary",
            bullet: "dot",
            translate: "MENU.MANAGE.FLEET_SUMMARY",
            page: "manage/fleet-summary",
            type: ["Administrator", "Super Admin"]
          },
          {
            title: "Driver Summary",
            bullet: "dot",
            translate: "MENU.MANAGE.DRIVER_SUMMARY",
            page: "manage/driver-summary",
            type: ["Administrator", "Super Admin"]
          },
		  
		  
        ]
      }
      ,
      {
        title: "Profile",
        root: true,
        icon: "flaticon2-avatar",
        page: "profile-master",
        bullet: "dot",
        translate: "MENU.PROFILE",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer"]
        //,
        // submenu: [
        //   {
        //     title: "View Profile",
        //     bullet: "dot",
        //     translate: "MENU.PROFILE.VIEW_PROFILE",
        //     page: "profile-master"
        //   }
        // ]
      },
	   
      {
        title: "Delivery Address",
        root: true,
        icon: "flaticon2-pin",
        page: "delivery-address",
        bullet: "dot",
        translate: "MENU.DELIVERYADDRESS",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer"]
      },
      {
        title: "Master",
        root: true,
        icon: "flaticon2-writing",
        page: "master",
        bullet: "dot",
        translate: "MENU.MASTER",
        type: ["Support User","Administrator","Super Admin"],
        submenu: [
          {
            title: "Price Master",
            bullet: "dot",
            translate: "MENU.MASTER.PRICE_MASTER",
            page: "master/price-master",
            type: ["Support User","Administrator","Super Admin"]
          },
		  {
            title: "Parent Complaint",
            bullet: "dot",
            translate: "MENU.MASTER.PARENT_COMPLAINT",
            page: "master/parentcompliant",
            type: ["Support User","Administrator","Super Admin"]
          },
          {
            title: "Child Complaint",
            bullet: "dot",
            translate: "MENU.MASTER.CHILD_COMPLAINT",
            page: "master/childcompliant",
            type: ["Support User","Administrator","Super Admin"]
          },
        ]
      },
      {
        title: "CRM",
        root: true,
        icon: "flaticon-rotate",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.CRM",
        type: ["Administrator", "Super Admin", "Partners-Management", "CRE", "Logistics"],
        submenu: [
          {
            title: "Customer Leads",
            bullet: "dot",
            translate: "MENU.CRM.CUSTOMER_LEADS",
            page: "crm/customer-leads",
            type: ["Administrator", "Super Admin"]
          },
          {
            title: "Partner Leads",
            bullet: "dot",
            translate: "MENU.CRM.PARTNER_LEADS",
            page: "crm/partner-leads",
            type: ["Administrator", "Super Admin"]
          }
        ]
      },
      {
        title: "Register Compliant",
        root: true,
        icon: "flaticon-computer",
        page: "Register Compliant",
        bullet: "dot",
        translate: "MENU.Compliant",
        type: ["Administrator", "Support User", "Super Admin", "CRE"],
		page: "register-compliant/compliant-list",
		custompage: ["/register-compliant/create-compliant","/register-compliant/edit-compliant", "CRE"]
      },
	   {
        title: "My Compliants",
        root: true,
        icon: "flaticon-computer",
        page: "My Compliants",
        bullet: "dot",
        translate: "MENU.Compliant",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer"],
		page: "register-compliant/compliant-list",
		custompage: ["/register-compliant/create-compliant","/register-compliant/edit-compliant","/register-compliant/create-compliant-user"]
      },
      {
        title: "Renewals",
        root: true,
        icon: "flaticon2-refresh",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.RENEWALS",
        type: ["Administrator", "Support User", "Super Admin"],
        submenu: [
          {
            title: "Apartment Customer Renewal",
            bullet: "dot",
            translate: "MENU.RENEWALS.APARTMENTCUSTOMERRENEWAL",
            page: "renewals/apartment-customer-renewal",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Corporate Customer Renewal",
            bullet: "dot",
            translate: "MENU.RENEWALS.CORPORATECUSTOMERRENEWAL",
            page: "renewals/corporate-customer-renewal",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Vehicle Insurance Renewal",
            bullet: "dot",
            translate: "MENU.RENEWALS.VEHICLEINSURANCERENEWAL",
            page: "renewals/vehicle-insurance-renewal",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Vehicle Fc Renewal",
            bullet: "dot",
            translate: "MENU.RENEWALS.VEHICLEFCRENEWAL",
            page: "renewals/vehicle-fc-renewal",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Driver License Renewal",
            bullet: "dot",
            translate: "MENU.RENEWALS.DRIVERLICENSERENEWAL",
            page: "renewals/driver-license-renewal",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Borewell Tds Renewal",
            bullet: "dot",
            translate: "MENU.RENEWALS.BOREWELLTDSRENEWAL",
            page: "renewals/borewell-tds-renewal",
            type: ["Administrator", "Support User", "Super Admin"]
          },
          {
            title: "Borewell License Renewal",
            bullet: "dot",
            translate: "MENU.RENEWALS.BOREWELLLICENSERENEWAL",
            page: "renewals/borewell-license-renewal",
            type: ["Administrator", "Support User", "Super Admin"]
          }

        ]
      },
      {
        title: "FAQ",
        root: true,
        icon: "flaticon-mail",
        page: "master/faq",
        bullet: "dot",
        translate: "MENU.FAQ",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer"]
      },
      {
        title: "My Profile",
        root: true,
        icon: "flaticon2-pin",
        page: "partner/partner-details",
        bullet: "dot",
        translate: "MENU.PARTNER_LOGIN.DETAILS",
        type: ["Partner"]
      },
      {
        title: "Assets",
        root: true,
        icon: "flaticon2-architecture-and-city",
        page: "partner-login/assets",
        bullet: "dot",
        translate: "MENU.PARTNER_LOGIN.ASSETS",
        type: ["Partner"]
      },
      {
        title: "Vehicle Driver Mapping",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "partner/fleet-driver-mapping",
        bullet: "dot",
        translate: "MENU.PARTNER.FLEET_DRIVER_MAPPING",
        type: ["Partner"]
      },
      {
        title: "Driver Location",
        bullet: "dot",
        icon: "flaticon2-delivery-truck",
        translate: "MENU.ZONE_MANAGEMENT.DRIVER",
        page: "zone-management/driver-location",
        type: ["Partner"]
      },
      {
        title: "MyOrder",
        root: true,
        icon: "flaticon2-delivery-truck",
        page: "dashboard",
        bullet: "dot",
        translate: "MENU.PARTNER.MYORDER",
        type: ["Partner"],
        submenu: [
          {
            title: "Scheduled Order",
            bullet: "dot",
            translate: "MENU.PARTNER.SCHEDULED_ORDER",
            page: "partner/scheduled-order",
            type: ["Partner"]
          },
          {
            title: "Completed Order",
            bullet: "dot",
            translate: "MENU.PARTNER.COMPLETED_ORDER",
            page: "partner/completed-order",
            type: ["Partner"]
          }
        ]
      },
	  {
        title: "Settings",
        root: true,
        icon: "flaticon2-gear",
        page: "config-setting",
        bullet: "dot",
        translate: "MENU.SETTING",
        type: ["Administrator", "Support User", "Super Admin"],
        submenu: [
          {
            title: "Notification",
            bullet: "dot",
            translate: "MENU.CONFIG.SETTINGS",
            page: "config-setting/configuration"
          },
		  {
            title: "Payment Method",
            bullet: "dot",
            translate: "MENU.CONFIG.PAYMENT_METHOD",
            page: "config-setting/payment"
          },
		  {
            title: "Firebase Setting",
            bullet: "dot",
            translate: "MENU.CONFIG.FIREBASE_SETTING",
            page: "config-setting/firebase"
          },
		  {
            title: "Driver Settings",
            bullet: "dot",
            translate: "MENU.MANAGE.SETTINGS",
            page: "settings/general/configuration",
            type: ["Administrator", "Super Admin"]
          }
        ]
      },
      {
        title: "FAQ",
        root: true,
        icon: "flaticon-mail",
        page: "master/driverfaq",
        bullet: "dot",
        translate: "MENU.PARTNERFAQ",
        type: ["Partner"]
      },
	  {
        title: "",
        root: true,
        icon: "",
        page: "",
        bullet: "",
        translate: "",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer", "Administrator", "Super Admin", "Support User", "Partner"]
      },{
        title: "",
        root: true,
        icon: "",
        page: "",
        bullet: "",
        translate: "",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer", "Administrator", "Super Admin", "Support User", "Partner"]
      },{
        title: "",
        root: true,
        icon: "",
        page: "",
        bullet: "",
        translate: "",
        type: ["Corporate Customer", "Apartment Customer", "Individual Customer", "Administrator", "Super Admin", "Support User", "Partner"]
      },
    ]
  }
};